import { useEffect, useState } from 'react';
import { Close } from '@mui/icons-material';

import type { Toast as ToastItem } from 'services/store/features/toasts/types';

import styles from './Toasts.module.css';

interface ToastProps {
  item: ToastItem,
  autoDeleteTime: number,
  actions: {
    removeToast: (id: number) => void
  }
}

function Toast({ item, autoDeleteTime = 2500, actions }: ToastProps) {
  const [time, setTime] = useState(0);
  const [unmountTransition, setUnmountTransition] = useState(false);

  useEffect(() => {
    if (item.autoDeleteTime) {
      const setTimeInterval = setInterval(
        () => setTime((state) => state + 40),
        40,
      );
      const interval = setInterval(() => {
        setUnmountTransition(true);
        clearInterval(setTimeInterval);
      }, autoDeleteTime);
      return () => {
        clearInterval(interval);
        clearInterval(setTimeInterval);
      };
    }
    return undefined;
  }, []);

  return (
    <div
      className={`${styles.toast} ${(unmountTransition) ? styles.hideToast : ''}`}
      onAnimationEnd={() => {
        if (unmountTransition && item.id) {
          actions.removeToast(item.id);
        }
      }}
    >
      <div
        className={styles.time}
        style={{
          backgroundColor: item.color,
          width: (item.autoDeleteTime) ? `${(time * 100) / autoDeleteTime}%` : '100%',
        }}
      />
      <div className={styles.content}>
        <i style={{ color: item.color }}>
          {item.icon}
        </i>
        <div className={styles.textContainer}>
          <p className={styles.title}>
            {item.title}
          </p>
          <p className={styles.description}>
            {item.description}
          </p>
        </div>
        <button
          type="button"
          className={styles.button}
          onClick={() => setUnmountTransition(true)}
        >
          <Close className={styles.icon} />
        </button>
      </div>
    </div>
  );
}

interface ToastsProps {
  list: ToastItem[],
  autoDeleteTime: number,
  actions: {
    removeToast: (id: number) => void
  }
}

export default function Toasts({ list, autoDeleteTime, actions }: ToastsProps) {
  return (
    <div className={styles.toastContainer}>
      {
        list && list.map((toast) => (
          <Toast
            key={toast.id}
            item={toast}
            autoDeleteTime={autoDeleteTime}
            actions={actions}
          />
        ))
      }
    </div>
  );
}
